export const propertyCompatibilityReasonList = Object.freeze([
  { value: 'FLOOR_HEATING', name: 'Fußbodenheizung' },
  { value: 'ONE_PIPE_HEATING', name: 'Einrohrheizung' },
  { value: 'OTHER', name: 'Sonstiges' },
]);
